/** Experience values stored in user_csat.experience (Application / Reimbursement). */
export const CSAT_EXPERIENCE_APPLICATION = 'Application'
export const CSAT_EXPERIENCE_REIMBURSEMENT = 'Reimbursement'

export type CsatExperienceType =
  | typeof CSAT_EXPERIENCE_APPLICATION
  | typeof CSAT_EXPERIENCE_REIMBURSEMENT

export const CSAT_HEADER = 'Liberty Rent would appreciate your feedback!'

export const CSAT_SUBMIT_SUCCESS_MESSAGE = 'Your response has been recorded. Thank you!'

export const CSAT_BODY_BY_EXPERIENCE: Record<CsatExperienceType, string> = {
  [CSAT_EXPERIENCE_APPLICATION]:
    'How easy or difficult was it to complete this application?',
  [CSAT_EXPERIENCE_REIMBURSEMENT]:
    'How easy or difficult was it to complete this Reimbursement Request?',
}

export const CSAT_SCORE_LABELS: Record<1 | 2 | 3 | 4 | 5, string> = {
  1: 'Very difficult',
  2: 'Somewhat difficult',
  3: 'Neither easy nor difficult',
  4: 'Somewhat easy',
  5: 'Very easy',
}
